import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { challengeListQueries } from '@infl-ts/util-fetch-challenge-list';
import { ListItemButton } from '@mui/material';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { saveForLaterFailure, saveForLaterSuccess } from './alerts';
import { useSaveForLater } from './mutations';
import { jsx as _jsx } from "react/jsx-runtime";

var AncillaryAction = function AncillaryAction(_ref) {
  var text = _ref.text,
      handleClick = _ref.handleClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return /*#__PURE__*/_jsx(ListItemButton, {
    alignItems: "flex-start",
    onClick: handleClick,
    disabled: disabled,
    "data-element": "ListItemButton",
    "data-component": "AncillaryAction",
    "data-source-file": "save-for-later.tsx",
    children: text
  });
};

var SaveForLater = function SaveForLater(_ref2) {
  var _ref2$challenge = _ref2.challenge,
      id = _ref2$challenge.id,
      headline = _ref2$challenge.headline,
      onCompleteAction = _ref2.onCompleteAction,
      hasBeenDismissedAlready = _ref2.hasBeenDismissedAlready,
      hideSaveForLater = _ref2.hideSaveForLater;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useSaveForLater = useSaveForLater({
    onCompleted: E.match(function () {
      return showAlert(saveForLaterFailure(headline, t));
    }, function (_ref3) {
      var saveForLater = _ref3.saveForLater;
      return pipe(headline, saveForLater.__typename === 'SaveForLaterResult' ? function (headline) {
        onCompleteAction && onCompleteAction();
        return saveForLaterSuccess(headline, t);
      } : function () {
        return saveForLaterFailure(headline, t);
      }, showAlert);
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(function (e) {
        return console.error(e);
      }, function (_ref4) {
        var saveForLater = _ref4.saveForLater;

        if (saveForLater.__typename === 'SaveForLaterResult') {
          cache.evict({
            id: cache.identify(saveForLater.challenge)
          });
          cache.evict({
            id: cache.identify(makeReference('ROOT_QUERY')),
            fieldName: 'savedForLaterChallenges'
          });
          cache.evict({
            id: cache.identify(makeReference('ROOT_QUERY')),
            fieldName: 'challengeCategories'
          });
          cache.gc();
        }
      }));
    },
    refetchQueries: challengeListQueries
  }),
      _useSaveForLater2 = _slicedToArray(_useSaveForLater, 1),
      saveForLater = _useSaveForLater2[0];

  return !(hasBeenDismissedAlready || hideSaveForLater) ? /*#__PURE__*/_jsx(AncillaryAction, {
    text: t('Save for later'),
    handleClick: function handleClick() {
      return saveForLater({
        variables: {
          input: {
            challengeId: id
          }
        }
      });
    }
  }) : null;
};

export default SaveForLater;